import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { CameraIcon, IdIcon, PaperStackIcon, UploadIcon } from '@motorway/mw-highway-code';

import { DOCUMENT_KINDS } from '../../../DocumentCapture.helpers';
import { ExampleDocuments } from '../../ExampleDocuments/ExampleDocuments';
import { EXAMPLE_DOCUMENTS } from '../../ExampleDocuments/ExampleDocuments.helpers';
import LocalTexts from '../../UploadDocuments.texts.json';

import styles from './UploadDocumentsVerification.scss';

const LocalT = new MDText(LocalTexts.uploadDocumentsVerification);

const Icon = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <div className={cx(styles.stepIcon, className)}>
    {children}
  </div>
);

export const UploadVerificationSteps = ({ showFSLStep = false }: { showFSLStep?: boolean }) => [
  {
    content: (
      <>
        <Icon>
          <IdIcon />
        </Icon>

        <p data-thc-style-override>
          {LocalT.translate('steps.snapYourDrivingLicence', {
            drivingLicence: <span className={styles.exampleDocLink}>
              <ExampleDocuments
                {
                  ...EXAMPLE_DOCUMENTS[
                DOCUMENT_KINDS.DRIVING_LICENCE as keyof typeof EXAMPLE_DOCUMENTS
                  ] as Record<string, unknown>
                }
                actionLink={LocalT.translate('steps.drivingLicence') as string}
                documentTitle={LocalT.translate('steps.drivingLicenceModalTitle') as string}
                modalDescription={LocalT.translate('steps.drivingLicenceModalDescription') as string}
              />
            </span>,
          })}
        </p>
      </>
    ),
    id: 1,
  },
  {
    content:
      <>
        <Icon>
          <CameraIcon filled={false} />
        </Icon>
        <p data-thc-style-override>{LocalT.translate('steps.takeASelfie')}</p>
      </>,
    id: 2,
  },
  {
    content: (
      <>
        <Icon>
          <PaperStackIcon />
        </Icon>
        <p data-thc-style-override>
          {LocalT.translate('steps.uploadYourDocument', {
            document: <span className={styles.exampleDocLink}>
              <ExampleDocuments
                {...EXAMPLE_DOCUMENTS[DOCUMENT_KINDS.V5 as keyof typeof EXAMPLE_DOCUMENTS] as Record<string, unknown>}
                actionLink={LocalT.translate('steps.v5c') as string}
                documentTitle={LocalT.translate('steps.v5c') as string}
                modalDescription={LocalT.translate('steps.v5cModalDescription') as string}
              />
            </span>,
          })}
        </p>
      </>
    ),
    id: 3,
  },
  ...(showFSLStep ? [{
    content: (
      <>
        <Icon className={styles.financeSettlementLetterIcon}>
          <UploadIcon />
        </Icon>
        <p data-thc-style-override>
          {LocalT.translate('steps.uploadYourDocument', {
            document: <span className={styles.exampleDocLink}>
              <ExampleDocuments
                {...EXAMPLE_DOCUMENTS[
                  DOCUMENT_KINDS.FINANCE_SETTLEMENT_LETTER as keyof typeof EXAMPLE_DOCUMENTS
                ] as Record<string, unknown>}
                actionLink={LocalT.translate('steps.financeSettlementLetter') as string}
                documentTitle={LocalT.translate('steps.financeSettlementLetter') as string}
                modalDescription={LocalT.translate('steps.financeSettlementLetterModalDescription') as string}
                modalSummaryList={LocalTexts.uploadDocumentsVerification.steps.financeSettlementLetterModalChecklist
                  .map((text) => LocalT.translate(text))}
              />
            </span>,
          })}
        </p>
      </>
    ),
    id: 4,
  }] : []),
];
